import React, { FC } from 'react';
import ContentLoader from '@adsk/alloy-react-content-loader';

const ProductLinksLoader: FC = () => (
  <ContentLoader data-testid="ProductLinksLoader" height={96} width={160}>
    <rect height="8" rx="6" ry="6" width="160" x="0" y="8" />
    <rect height="8" rx="6" ry="6" width="160" x="0" y="24" />
    <rect height="8" rx="6" ry="6" width="160" x="0" y="40" />
    <rect height="8" rx="6" ry="6" width="160" x="0" y="56" />
    <rect height="8" rx="6" ry="6" width="160" x="0" y="72" />
    <rect height="8" rx="6" ry="6" width="160" x="0" y="88" />
  </ContentLoader>
);

export default ProductLinksLoader;
